import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapModuleComponent } from './map-module.component';
import {MapModule} from "@shopping-angular-components/map";

@NgModule({
  declarations: [
    MapModuleComponent
  ],
  exports: [
    MapModuleComponent
  ],
  imports: [
    CommonModule,
    MapModule
  ]
})
export class MapModuleModule { }
